"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isNil = _interopRequireDefault(require("lodash-es/isNil"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(params) {
  var query = Object.entries(params || {}).filter(function (pair) {
    return !(0, _isNil["default"])(pair[1]);
  }).map(function (pair) {
    return pair.map(function (v) {
      return encodeURIComponent(String(v));
    }).join('=');
  }).join('&');
  return query ? "?" + query : query;
};

exports["default"] = _default;